import { Controller, useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ImageUp } from "lucide-react";
import { ImageUploadCropper } from "../../../../../../components/image-upload-cropper";
import type { EventEditorFormValues } from "../event.scheme";
import { renderError, SectionTitle, type CommonProps } from "./shared";

type Props = CommonProps & { required?: boolean };

export function EventImageSection({ isSubmitting, canEditField, required }: Props) {
  const { control, setValue, clearErrors } = useFormContext<EventEditorFormValues>();
  const imageUrl = useWatch({ control, name: "imageUrl" });
  const { t } = useTranslation();

  return (
    <section className="event-form-section">
      <SectionTitle icon={<ImageUp className="h-4 w-4" />}>
        {t("event.event_image")}
        {required ? (
          <span
            className="ml-1 text-red-500"
            aria-hidden="true"
          >
            *
          </span>
        ) : null}
      </SectionTitle>
      <Controller
        control={control}
        name="image"
        render={({ field, fieldState }) => (
          <>
            <ImageUploadCropper
              value={field.value || imageUrl || null}
              onChange={(file) => {
                field.onChange(file);
                setValue("imageUrl", "", { shouldDirty: true, shouldValidate: true });
                clearErrors("image");
              }}
              aspect={2.3}
              title={t("event.event_image")}
              description="Drag & drop or click to select image"
              disabled={isSubmitting || !canEditField("image")}
              outputFileName="event_image.jpg"
            />
            {renderError(fieldState.error?.message)}
          </>
        )}
      />
    </section>
  );
}
